const initialState = [
];

export default function affiliates(state = initialState, action) {
    switch (action.type) {
        case 'SET_AFFILIATES':
            return action.value;
        default:
            return state;
    }
}
